exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n\n/* Sync for Science Discovery DiscoveryApp Stylesheet */\n\n/* v.01.08 Updated 9/05/2019 */\n\nbody {\n   font-size: 16px;\n\tbackground-color: var(--background-application);\n   padding: 0;\n   margin: 0;\n\toverflow: hidden;\n}\n\nbutton:focus {\n\toutline: none;\n}\n\n.discovery-app {\n   position: fixed;\n   top: 0;\n   left: 0;\n   z-index: -10;\n   height: calc(100% - 10px); \n   width: 100%;\n\tmin-width: 1024px;\n   background-color: var(--background-application);\n   padding: 0;\n   margin: 0;\n   overflow-x: hidden;\n   overflow-y: hidden; \n}\n", ""]);

// exports
